import {
  LANG,
  LANG_ES,
  LANG_EN,
  LANG_ATTRIBUTE_TAG,
  ES_LANG_ATTRIBUTE_TAG,
  EN_LANG_ATTRIBUTE_TAG,
} from "@/constants/Language";

const getLanguageCode = (langCode: LANG): LANG_ATTRIBUTE_TAG => {
  switch (langCode) {
    case LANG_ES:
      return ES_LANG_ATTRIBUTE_TAG;
    case LANG_EN:
      return EN_LANG_ATTRIBUTE_TAG;
    default:
      return undefined as unknown as LANG_ATTRIBUTE_TAG;
  }
};

export default getLanguageCode;
